import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import {
    PdpSharedDescriptionAdditionalOptionsContent,
    Title,
} from './PdpSharedDescriptionAdditionalOptionsContent';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

function PdpSharedDescriptionAdditionalOptionsComponent(props) {
    const {
        headerClass,
        contentClass,
        wrapperClass,
        item,
        user,
        viewer,
        buttonType,
        collapsedHeight,
    } = props;
    const { isCustomizable, isJewelry } = item;
    const customizationOptions = get(item, 'attributes.customizable[0].text');

    if (!isCustomizable || !customizationOptions) {
        return null;
    }

    return (
        <div
            data-tn="pdp-item-description-customization-options"
            className={classNames(styles.wrapper, wrapperClass)}
        >
            <h2 className={classNames(styles.header, headerClass)}>
                <Title isJewelry={isJewelry} />
            </h2>
            <PdpSharedDescriptionAdditionalOptionsContent
                customizationOptions={customizationOptions}
                contentClass={contentClass}
                collapsedHeight={collapsedHeight}
                buttonType={buttonType}
                item={item}
                user={user}
                viewer={viewer}
            />
        </div>
    );
}

PdpSharedDescriptionAdditionalOptionsComponent.propTypes = {
    wrapperClass: PropTypes.string,
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    collapsedHeight: PropTypes.string,
    buttonType: PropTypes.string,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    viewer: PropTypes.object,
};

export const PdpSharedDescriptionAdditionalOptions = createFragmentContainer(
    PdpSharedDescriptionAdditionalOptionsComponent,
    {
        user: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_user on User {
                ...PdpSharedDescriptionAdditionalOptionsContent_user
            }
        `,
        item: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_item on Item {
                ...PdpSharedDescriptionAdditionalOptionsContent_item
                isJewelry
                isCustomizable
                attributes {
                    customizable {
                        text
                    }
                }
            }
        `,
        viewer: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_viewer on Viewer {
                ...PdpSharedDescriptionAdditionalOptionsContent_viewer
            }
        `,
    }
);
